<template>
  <basepage
    :title="$t('Save-Received-E-Invoices-Archive')"
    :status="status"
    :menuitems="menuItems"
    v-on:menuclick="menuClick"
  >
    <template slot="toolbar">
      <!--
    <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details :label="this.$t('Search')" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
    -->
    </template>

    <v-layout v-if="StatusUI.buttonBaslat">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0"> {{ $t('Select-Period') }} </h3>
            </div>
          </v-card-title>

          <div>
            <tarihcomp
              :etiket="$t('Date') + ' 1'"
              :detaygizle="false"
              v-model="prm.Tarih1"
              v-bind:defaultvalue="'ok'"
              :rules="[(v) => !!v || $t('Please-select-a-date')]"
            ></tarihcomp>

            <tarihcomp
              :etiket="$t('Date') + ' 2'"
              :detaygizle="false"
              v-model="prm.Tarih2"
              v-bind:defaultvalue="'ok'"
              :rules="[(v) => !!v || $t('Please-select-a-date')]"
            ></tarihcomp>
          </div>


          <div v-if="StatusUI.hataOlustu">
            {{ $t('Error') }} : {{StatusUI.aciklama}}            
            <code>
            {{StatusUI.hataMesaji}}
            </code>
            
          </div>

          <v-card-actions>
            <v-btn
              :disabled="status.loading || !StatusUI.buttonBaslat"
              flat
              color="orange"
              @click="edfeterexport()"
              > {{ $t('Save-to-Archive') }} </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout v-if="StatusUI.buttonYenile">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">e-Faturalar Havuza Aktarılıyor</h3>
              <div> {{ $t('Commencement-Period') }}  : {{ StatusUI.parametre.Tarih1 }}</div>
              <div>{{ $t('Termination-Period') }} : {{ StatusUI.parametre.Tarih2 }}</div>
              <div>{{ StatusUI.aciklama }}</div>

              <div></div>
              <v-progress-linear color="green" v-model="yuzde" height="25">
                <strong>{{ Math.ceil(yuzde) }}%</strong>
              </v-progress-linear>
            </div>
          </v-card-title>

          <v-card-actions>
            <v-btn
              :disabled="status.loading || !StatusUI.buttonYenile"
              flat
              color="orange"
              @click="yenile(10)"
              >({{ countDown }}) Yenile</v-btn
            >

            <v-btn
              :disabled="status.loading || !StatusUI.buttonYenile"
              flat
              color="orange"
              @click="sonlandir()"
              > {{ $t('Terminate') }} </v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout v-if="StatusUI.buttonIndir">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ $t('Received-e-Invoices-Recorded-Pool') }}</h3>
              <div> {{ $t('Commencement-Period') }}  : {{ StatusUI.parametre.Tarih1 }}</div>
              <div> {{ $t('Termination-Period') }}  : {{ StatusUI.parametre.Tarih2 }}</div>
              <div> {{ $t('Number-of-Recorded-Invoices') }}  : {{ StatusUI.sonuc.KaydedilenFaturaSayisi }}</div>
              
            </div>
          </v-card-title>

          <v-card-actions>
            
            <v-btn
              :disabled="status.loading || !StatusUI.buttonIndir"
              flat
              color="orange"
              @click="sil()"
              >{{ $t('New') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

  </basepage>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "@/components/app/coper/tools.js";
import tarihcomp from "@/components/app/customcomp/tarihim";

export default {
  components: {
    basepage,
    tarihcomp,
  },
  data() {
    return {
      status: tool.NewSatatus(),
      countDown: 10,
      MaxCountDown: 10,

      StatusUI: {
        buttonIndir: false,
        buttonBaslat: false,
        buttonYenile: false,
        TblTask: {},
      },

      yuzde: 0,
      prm: {
        Tarih1: tool.Now_yyyy_MM_dd(),
        Tarih2: tool.Now_yyyy_MM_dd(),
        Sonlandir: false,
      },
      response: [],

      aranacak: "",
      menuItems: [
        {
          title: "Entegratör",
        },
        
      ],
    };
  },
  methods: {
    countDownTimer() {
      setTimeout(() => {
        if ((this.StatusUI.buttonYenile == true) && (this.status.loading==false)) {
          this.countDown -= 1;
          if (this.countDown <= 0) {
            this.MaxCountDown++;
            this.countDown = this.MaxCountDown;
            this.yenile(10);
          }
        }
        this.countDownTimer();
      }, 1000);
    },
    menuClick(index) {
      if (index == 0) {
        //TODO : Entegratör Ayar sayfası açılacak
      }
    },
    kayitgetir() {},
    edfeterexport: edfeterexport,
    sonlandir: sonlandir,

    sil: sil,
    dosyaIndir: dosyaIndir,
    yenile: yenile,
  },

  beforeMount: beforeMount,
};

function beforeMount() {
  this.yenile(10);
  this.countDownTimer();
}

function yenile(milisaniye) {
  this.countDown = this.MaxCountDown;
  this.status.loading = true;
  setTimeout(() => {
    var prm = {};
    tool.api_post(this, "EFatura/GelenEFaturaStatus", prm).then(
      (response) => {
        this.StatusUI = response.body.data;

        if (response.body.data.TblTask != null) {
          this.yuzde = response.body.data.TblTask.Value;
        }
        this.status.loading = false;
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, milisaniye);
}

function edfeterexport() {
  let prm = this.prm;
  prm.Sonlandir = false;
  prm.Sil = false;

  this.status.loading = true;
  tool.api_post(this, "EFatura/HavuzaKayit", prm).then(
    (response) => {
      this.response = response.body;

      if (response.body.Status == true) {
        //this.status.text = response.body.Message;
        //this.status.show = true;
        //this.yuzde = 0;

        this.MaxCountDown=10;
        this.yenile(5000);
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;

        if (response.body.TaskInfo != null) {
          if (response.body.TaskInfo.Status == 2) {
            //Devam ediyor
            this.yuzde = response.body.TaskInfo.Value;
          }
          if (response.body.TaskInfo.Status == 3) {
            //Tamamlandı
            this.yuzde = response.body.TaskInfo.Value;
          }
        }
        this.status.loading = false;
      }
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function sonlandir() {
  let prm = this.prm;
  prm.Sonlandir = true;
  prm.Sil = false;

  this.status.loading = true;
  tool.api_post(this, "EFatura/HavuzaKayit", prm).then(
    (response) => {
      if (response.body.Status == true) {
        this.status.text = response.body.Message;
        this.status.show = true;
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;
      }
      this.StatusUI = response.body.TaskInfoUI;
      this.status.loading = false;
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}

function dosyaIndir() {
  var prm = {};

  this.status.loading = true;
  setTimeout(() => {
    tool.api_post_FileDownload(this, "EDefter/EDefterDosyaIndir", prm).then(
      (response) => {
        tool.CreateDownloadLink(response, "edefter");
        this.status.text = "Dosya İndiriliyor";
        this.status.show = true;
        this.status.loading = false;
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, 5000);
}

function sil() {
  let prm = this.prm;
  prm.Sonlandir = false;
  prm.Sil = true;

  this.status.loading = true;
  tool.api_post(this, "EFatura/HavuzaKayit", prm).then(
    (response) => {
      if (response.body.Status == true) {
        //this.status.text = response.body.Message;
        //this.status.show = true;
      } else {
        this.status.text = response.body.ErrorList[0];
        this.status.show = true;
      }
      this.StatusUI = response.body.TaskInfoUI;
      this.status.loading = false;
    },
    (response) => {
      this.status = tool.responseToStatus(response);
    }
  );
}
</script>
